export const buildInfo = { version: '1.0.53+f1be5b1' };
